import { api } from '../api/client.js';
import { ENDPOINTS } from '../api/endpoints.js';
import { API_CONFIG } from '../api/config.js';
import { mockNotifications } from '../mocks/notifications.js';

const delay = (ms = 150) => new Promise((r) => setTimeout(r, ms));

export const notificationsService = {
  async list() {
    if (API_CONFIG.useMocks) { await delay(); return mockNotifications; }
    return api.get(ENDPOINTS.notifications.list());
  },
  async markRead(id) {
    if (API_CONFIG.useMocks) { await delay(80); return { id, read: true }; }
    return api.post(ENDPOINTS.notifications.markRead(id));
  },
};